import { useStaticQuery, graphql } from "gatsby";

export interface SocialConfig {
  twitter: {
    handle: string;
  };
  // For now instagram is unused.
  instagram: {
    handle: string;
  };
  facebook: {
    handle: string;
  };
  linkedin: {
    handle: string;
  };
}

export const useSocialConfigData: () => SocialConfig = () => {
  const { site } = useStaticQuery(
    graphql`
      query SocialConfigQuery {
        site {
          siteMetadata {
            social {
              twitter {
                handle
              }
              instagram {
                handle
              }
              facebook {
                handle
              }
              linkedin {
                handle
              }
            }
          }
        }
      }
    `
  );
  return site.siteMetadata.social;
};
